import type { TFunction } from "i18next";
import type { NegotiationRoundDto } from "../../../autogen/bff-api";

export const stageLabel = (t: TFunction, round: NegotiationRoundDto | null): string =>
  round
    ? `${t("Negotiation round")} ${round.roundNumber}${round.isFinalRound ? ` — ${t("Final Round")}` : ""}`
    : t("Original sourcing event");
